import Typography from "../../../designComponents/Typography";
import Button from "../../../designComponents/Button";
import Table from "../../../designComponents/Table";
import { useEffect, useState } from "react";
import requestAPI from "../../../utils/requestAPI";
import jobs from "../../../apiConfigs/jobs";
import { useParams } from "react-router-dom";
import { DetailsWrapperStyled, InfoRowStyled } from "../../Properties/Details";

type Props = {};

const JobDetails = (props: Props) => {
  const { jobId } = useParams();
  const [jobDetail, setJobDetail] = useState();

  const getJobDetails = async (id: string) => {
    try {
      const response = await requestAPI(jobs.getSingleJob(id));
      setJobDetail(response);
    } catch (error) {
    }
  };


  useEffect(() => {
    if (jobId) {
      getJobDetails(jobId);
    }
  }, []);
  const tableData = {
    headings: [
      { key: "name", label: "Name" },
      { key: "email", label: "Email Address" },
      { key: "role", label: "Role" },
      { key: "actions", label: "Actions" },
    ],
    body: [
      {
        id: "",
        name: "Nitish Rajak",
        email: "nitishrajak1@gmail.com",
        role: "Landlord",
        actions: (
          <div
            style={{
              display: "flex",
              gap: "4px",
              justifyContent: "flex-end",
            }}
          >
            <Button variant="gray" radius="normal" onClick={() => {}}>
              View Profile
            </Button>
          </div>
        ),
      },
    ],
  };
  return (
    <div>
      <div style={{ marginTop: "20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ display: "flex", gap: "70px", alignItems: "center" }}>
            <Typography size="h3" fontWeight="medium">
              Light Fixing
            </Typography>
            <Typography
              style={{
                backgroundColor: "#00DE90",
                color: "white",
                padding: "0px 10px",
                borderRadius: "10px",
                textAlign: "center",
              }}
            >
              Active
            </Typography>
          </div>
          <div>
            <Button variant="danger">Delete Job</Button>
          </div>
        </div>
        <div>
          <Typography size="h4" style={{ color: "gray" }}>
            €10.00{" "}
          </Typography>
        </div>
      </div>

      <Typography
        style={{ marginBottom: "10px", marginTop: "20px" }}
        fontWeight="medium"
      >
        Job Description
      </Typography>
      <Typography size="h5" style={{ color: "gray", marginBottom: "50px" }}>
        Lorem ipsum dolor sit amet consectetur. Vivamus purus vel velit nunc in
        arcu cursus eget neque. Risus pellentesque pretium erat eget. Imperdiet
        gravida mauris sed lectus fusce in mi neque. Imperdiet eu dolor nec
        donec ultricies. Ipsum ultricies amet amet proin leo dictum felis
        habitasse. Cras pharetra sociis congue bibendum at. Adipiscing placerat
        lorem tincidunt urna sit natoque placerat dui lectus. Neque ipsum lectus
        at vitae erat faucibus vitae at. Non amet suspendisse risus neque nisi
        leo. Malesuada vel leo nulla vitae tincidunt eget faucibus fermentum.
        Dapibus velit viverra lobortis arcu quis vestibulum tristique.
      </Typography>
      <DetailsWrapperStyled>
        <Typography style={{ marginBottom: "10px" }} fontWeight="medium">
          Job Details
        </Typography>

        <InfoRowStyled>
          <Typography size="h5" style={{ width: "120px" }}>
            Rate
          </Typography>
          <Typography style={{ color: "gray" }}>€10.00</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography size="h5" style={{ width: "120px" }}>
            Address
          </Typography>
          <Typography style={{ color: "gray" }}>
            Kavanagh Ave, Cherry Orchard, Dublin, Ireland
          </Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography size="h5" style={{ width: "120px" }}>
            Created At
          </Typography>
          <Typography style={{ color: "gray" }}>
            2023-09-28T09:28:18.000Z
          </Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography size="h5" style={{ width: "120px" }}>
            Updated At
          </Typography>
          <Typography style={{ color: "gray" }}>
            2023-09-28T09:28:45.000Z
          </Typography>
        </InfoRowStyled>
      </DetailsWrapperStyled>

      <Typography
        style={{ marginBottom: "10px", marginTop: "20px" }}
        fontWeight="medium"
      >
        Job Created By
      </Typography>

      <Table
        tableData={tableData}
        // isLoading={isLoading}
        noData="No data to display."
        headingBgColor="#f0f0f0"
        showMenuIcon={false}
        evenRowBgColor="#fafafa"
      />
    </div>
  );
};

export default JobDetails;
